import React from "react";
import Head from "next/head";
import { ComingSoonForm, ComingSoonHero } from "@modules/study/comingsoon";
import { ContactusMap } from "@modules/study/contactus";

const Jobs = () => {
  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>
          Welcome to UniSearch the complete platform for students and
          universities
        </title>
      </Head>
      <ComingSoonHero />
      <ComingSoonForm />
      <ContactusMap />
    </>
  );
};

export default Jobs;
